(() => {
  "use strict";
  function e() {
    var e = 0.01 * window.innerHeight;
    document.documentElement.style.setProperty("--vh", "".concat(e, "px"));
  }
  function t() {
    var e = document.querySelector(".smart-header").clientHeight;
    document.documentElement.style.setProperty(
      "--header-height",
      "".concat(e, "px"),
    );
  }
  document.addEventListener("DOMContentLoaded", function () {
    e(), t();
  }),
    window.addEventListener("resize", function () {
      e(), t();
    });
})();
